export default "__VITE_ASSET__sHR9zpro__"